// extracted by mini-css-extract-plugin
module.exports = {"root":"item_root__18i3f","free":"item_free__2PhGJ","center":"item_center__yEgxW","check":"item_check__1AL3R","handwriting":"item_handwriting__1sVP-","tight":"item_tight__mMXVF"};